var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EdelError } from "./interfaces/errors";
import { accountDetails } from "../../mainDi/webDi";
import * as URLConfig from "@frameworks/web/config/domain";
import { encryption, decryption } from "./encryption";
var TOKEN = "jwt_token";
var GAUTH = "Gauth";
var CONTENT_TYPE = "Content-Type";
var CONTET_TYPE_VALUE = "application/json";
var APP_ID_KEY = "AppIdKey";
var APP_ID_VALUE = URLConfig.config.appIdKey;
var SOURCE = "Source";
var SOURCE_VALUE = "EDEL";
var AUTHORIZATION = "Authorization";
var PLATFORM = "platform";
var PLATFORM_VALUE = "admin ";
var Http = /** @class */ (function () {
    function Http(autorize, storage) {
        this.autorize = autorize;
        this.localStorage = storage;
    }
    Http.prototype.getDownloadableFile = function (blob, disposition) {
        var filename = "file";
        if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
            }
            return new File([blob], filename);
        }
    };
    Http.prototype.makeApiCall = function (requestOption) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var option, getEncryptedData, serverKey, error_1;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        option = {
                            method: requestOption.method,
                            signal: requestOption.signal,
                        };
                        if (!((requestOption === null || requestOption === void 0 ? void 0 : requestOption.encryption) && (requestOption === null || requestOption === void 0 ? void 0 : requestOption.body))) return [3 /*break*/, 6];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.localStorage.get("serverKey")];
                    case 2:
                        serverKey = _c.sent();
                        if (!serverKey)
                            serverKey = URLConfig.config.serverPublicKey;
                        return [4 /*yield*/, encryption(serverKey, JSON.stringify(requestOption.body))];
                    case 3:
                        getEncryptedData = _c.sent();
                        option.body = getEncryptedData.reqObj;
                        requestOption.headers = new Headers({
                            CPK: (_a = getEncryptedData === null || getEncryptedData === void 0 ? void 0 : getEncryptedData.header) === null || _a === void 0 ? void 0 : _a.CPK,
                            SEPRK: (_b = getEncryptedData === null || getEncryptedData === void 0 ? void 0 : getEncryptedData.header) === null || _b === void 0 ? void 0 : _b.SEPRK,
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _c.sent();
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        if ((requestOption === null || requestOption === void 0 ? void 0 : requestOption.body) && !(requestOption === null || requestOption === void 0 ? void 0 : requestOption.encryption)) {
                            option.body = JSON.stringify(requestOption.body);
                        }
                        _c.label = 7;
                    case 7: return [4 /*yield*/, this.appendHeaders(requestOption, option)];
                    case 8:
                        _c.sent();
                        return [2 /*return*/, fetch(requestOption.url, option)
                                .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.throwErrorIfResponseIsNotOk(requestOption, response, getEncryptedData === null || getEncryptedData === void 0 ? void 0 : getEncryptedData.rsaAoepKeyPair)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); })
                                .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                var contentType, ewjwt, GAuth, serverKey, disposition, blob, file, ewJwtToken, CEPRK, encParsedObject, decData, err_1, parsedObject;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            contentType = res.headers.get(CONTENT_TYPE);
                                            ewjwt = res.headers.get("ewjwt");
                                            GAuth = res.headers.get("GAuth");
                                            serverKey = res.headers.get("SPK");
                                            if (serverKey)
                                                this.localStorage.set("serverKey", serverKey);
                                            if (!(contentType == "application/force-download")) return [3 /*break*/, 2];
                                            disposition = res.headers.get("Content-Disposition");
                                            return [4 /*yield*/, res.blob()];
                                        case 1:
                                            blob = _a.sent();
                                            file = this.getDownloadableFile(blob, disposition);
                                            return [2 /*return*/, Promise.resolve(file)];
                                        case 2:
                                            if (ewjwt && ewjwt !== "") {
                                                ewJwtToken = ewjwt.split(" ");
                                                this.localStorage.set(TOKEN, ewJwtToken[1]);
                                            }
                                            this.GuestAuthSession(GAuth);
                                            if (!(requestOption === null || requestOption === void 0 ? void 0 : requestOption.encryption)) return [3 /*break*/, 9];
                                            _a.label = 3;
                                        case 3:
                                            _a.trys.push([3, 7, , 8]);
                                            return [4 /*yield*/, res.headers.get("CEPRK")];
                                        case 4:
                                            CEPRK = _a.sent();
                                            return [4 /*yield*/, res.json()];
                                        case 5:
                                            encParsedObject = _a.sent();
                                            return [4 /*yield*/, decryption(CEPRK, encParsedObject === null || encParsedObject === void 0 ? void 0 : encParsedObject.response, getEncryptedData === null || getEncryptedData === void 0 ? void 0 : getEncryptedData.rsaAoepKeyPair)];
                                        case 6:
                                            decData = _a.sent();
                                            return [2 /*return*/, decData];
                                        case 7:
                                            err_1 = _a.sent();
                                            console.log("errr***", err_1);
                                            return [3 /*break*/, 8];
                                        case 8: return [3 /*break*/, 11];
                                        case 9: return [4 /*yield*/, res.json()];
                                        case 10:
                                            parsedObject = _a.sent();
                                            return [2 /*return*/, parsedObject];
                                        case 11: return [2 /*return*/];
                                    }
                                });
                            }); })
                                .catch(function (reason) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    try {
                                        if (reason instanceof DOMException &&
                                            reason.code === DOMException.ABORT_ERR) {
                                            throw new EdelError(0, {
                                                status: false,
                                                error: {
                                                    errorCode: DOMException.ABORT_ERR.toString(),
                                                    actionCode: "0",
                                                    errorMessage: reason.message,
                                                },
                                            });
                                        }
                                        throw reason;
                                    }
                                    catch (error) {
                                        throw new EdelError(error.getHttpCode(), {
                                            status: error.getStatus(),
                                            error: {
                                                errorCode: error.getErrorCode() || error.getErrCd(),
                                                actionCode: error.getActionCode(),
                                                errorMessage: error.getErrorMessageOrErrMsg(),
                                            },
                                        });
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                }
            });
        });
    };
    Http.prototype.GuestAuthSession = function (GAuth) {
        if (GAuth && GAuth !== "")
            this.localStorage.set(GAUTH, GAuth);
    };
    Http.prototype.appendHeaders = function (requestOption, option) {
        return __awaiter(this, void 0, void 0, function () {
            var authToken, gauthToken, headers, lgnSrc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.autorize.getAuthToken()];
                    case 1:
                        authToken = _a.sent();
                        return [4 /*yield*/, this.localStorage.get(GAUTH)];
                    case 2:
                        gauthToken = _a.sent();
                        headers = new Headers();
                        headers.append(CONTENT_TYPE, CONTET_TYPE_VALUE);
                        requestOption.avoidAppID ? null : headers.append(APP_ID_KEY, APP_ID_VALUE);
                        if (!requestOption.avoidSOURCE)
                            headers.append(SOURCE, SOURCE_VALUE);
                        return [4 /*yield*/, accountDetails.getLoginSrc()];
                    case 3:
                        lgnSrc = _a.sent();
                        if (lgnSrc && lgnSrc === "nesttrader") {
                            headers.append(PLATFORM, PLATFORM_VALUE);
                        }
                        if ((requestOption === null || requestOption === void 0 ? void 0 : requestOption.getGauth) && gauthToken)
                            headers.append(GAUTH, gauthToken);
                        if (authToken && !requestOption.avoidAuthToken) {
                            headers.append(AUTHORIZATION, authToken);
                        }
                        if (requestOption === null || requestOption === void 0 ? void 0 : requestOption.headers) {
                            requestOption === null || requestOption === void 0 ? void 0 : requestOption.headers.forEach(function (key, value) {
                                headers.append(value, key);
                            });
                        }
                        option.headers = headers;
                        return [2 /*return*/];
                }
            });
        });
    };
    Http.prototype.throwErrorIfResponseIsNotOk = function (requestOption, response, rsaAoepKeyPair) {
        return __awaiter(this, void 0, void 0, function () {
            var errorParams, CEPRK, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!response.ok || response.status === 222)) return [3 /*break*/, 10];
                        errorParams = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        return [4 /*yield*/, response.json()];
                    case 2:
                        errorParams = _a.sent();
                        if (!(response.status === 401)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.localStorage.remove(TOKEN)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.localStorage.remove("acc_data")];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        if (!(requestOption === null || requestOption === void 0 ? void 0 : requestOption.encryption)) return [3 /*break*/, 7];
                        CEPRK = response.headers.get("CEPRK");
                        return [4 /*yield*/, decryption(CEPRK, errorParams.response, rsaAoepKeyPair)];
                    case 6:
                        // After getting response we need to decrypt the response
                        errorParams = _a.sent();
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_2 = _a.sent();
                        console.error("Parsing failed for error body");
                        return [3 /*break*/, 9];
                    case 9: throw new EdelError(response.status, errorParams);
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    Http.prototype.request = function (requestOption, shoudldParseResponse) {
        if (shoudldParseResponse === void 0) { shoudldParseResponse = true; }
        return __awaiter(this, void 0, void 0, function () {
            var authToken, option, headers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.autorize.getAuthToken(requestOption.isBearerToken)];
                    case 1:
                        authToken = _a.sent();
                        option = { method: requestOption.method };
                        headers = new Headers();
                        headers.append(CONTENT_TYPE, CONTET_TYPE_VALUE);
                        if (!requestOption.isBearerToken)
                            headers.append(APP_ID_KEY, APP_ID_VALUE);
                        headers.append(SOURCE, SOURCE_VALUE);
                        if (requestOption.isBearerToken) {
                            headers.append(PLATFORM, window.localStorage.getItem("isImpersonated")
                                ? "rm"
                                : window.localStorage.getItem("lgnSrc") === "android-phone"
                                    ? "android"
                                    : window.localStorage.getItem("lgnSrc") === "iphone"
                                        ? "ios"
                                        : window.localStorage.getItem("lgnSrc") === "X"
                                            ? "tx3"
                                            : "WEB");
                        }
                        if (authToken && !requestOption.avoidAuthToken) {
                            headers.append(AUTHORIZATION, authToken);
                        }
                        if (requestOption === null || requestOption === void 0 ? void 0 : requestOption.headers) {
                            requestOption === null || requestOption === void 0 ? void 0 : requestOption.headers.forEach(function (key, value) {
                                headers.append(value, key);
                            });
                        }
                        option.headers = headers;
                        if (requestOption === null || requestOption === void 0 ? void 0 : requestOption.body)
                            option.body = JSON.stringify(requestOption.body);
                        return [2 /*return*/, fetch(requestOption.url, option)
                                .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!!response.ok) return [3 /*break*/, 2];
                                            //http : 400-499
                                            return [4 /*yield*/, this.throwErrorIfResponseIsNotOk(requestOption, response)];
                                        case 1:
                                            //http : 400-499
                                            _a.sent();
                                            _a.label = 2;
                                        case 2: return [2 /*return*/, response];
                                    }
                                });
                            }); })
                                .then(function (res) {
                                if (shoudldParseResponse) {
                                    return res.json();
                                }
                                if (res.status === 200 ||
                                    res.status === 201 ||
                                    res.status === 202 ||
                                    res.status === 222)
                                    return res;
                                else
                                    console.log("Error", res);
                            })];
                }
            });
        });
    };
    return Http;
}());
export default Http;
